import { observer } from 'mobx-react';
import * as React from 'react';
import { Tooltip } from 'react-tooltip';
import clickOutsideStore from '../../ClickOutsideStore';

type State = {
  isOpen: boolean;
};

interface Props {
  tooltipId: string;
  className?: string;
  tooltipIcon: React.JSX.Element;
  children: React.JSX.Element;
}

class ClickableTooltip extends React.Component<Props> {
  state: State = {
    isOpen: false,
  };

  tooltipRef: React.RefObject<HTMLDivElement | null> = React.createRef();

  close = () => this.setState({ isOpen: false });

  toggle = () => {
    const { isOpen } = this.state;
    clickOutsideStore.addListener({ ref: this.tooltipRef, callback: this.close });
    this.setState({ isOpen: !isOpen });
  };

  render() {
    const { tooltipId, tooltipIcon, children, className } = this.props;
    return (
      <div className={className || 'pl-4 flex items-center'} ref={this.tooltipRef}>
        <button
          className="cursor-pointer text-xs"
          data-tooltip-id={tooltipId}
          aria-label="Show tooltip"
          onClick={() => this.toggle()}
        >
          {tooltipIcon}
        </button>
        <Tooltip
          id={tooltipId}
          place="bottom"
          style={{ borderRadius: '6px', width: '420px', zIndex: 10 }}
          clickable
          isOpen={this.state.isOpen}
        >
          <div className="py-1.5 text-xs">{children}</div>
        </Tooltip>
      </div>
    );
  }
}

export default observer(ClickableTooltip);
